import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./MinNavbar.css";

const MinNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");

  // 🧠 Detect current section on page load or refresh
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#products") {
      setActiveLink("shop");
    } else if (hash === "#contact") {
      setActiveLink("contact");
    } else {
      setActiveLink("home");
    }
  }, []);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setMenuOpen(false);
  };


  useEffect(() => {
  const sectionMap = {
    home: document.getElementById("home"),
    shop: document.getElementById("products"),
    contact: document.getElementById("contact"),
  };

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.6, // trigger when 60% is in view
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        if (id === "products") {
          setActiveLink("shop");
        } else if (id === "contact") {
          setActiveLink("contact");
        } else if (id === "home") {
          setActiveLink("home");
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  Object.values(sectionMap).forEach((section) => {
    if (section) observer.observe(section);
  });

  return () => {
    Object.values(sectionMap).forEach((section) => {
      if (section) observer.unobserve(section);
    });
  };
}, []);



  return (
    <nav className="navbar-wrapper">
      <div className="main-navbar">
        <div
          className="hamburger-icon d-md-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`navbar-nav ${menuOpen ? "menu-open" : "menu-closed"}`}>
          <li className="nav-item">
            <a
              href="/"
              onClick={() => handleLinkClick("home")}
              className={activeLink === "home" ? "active-link" : ""}
            >
              <i className="bi bi-house-door-fill"></i> HOME
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#products"
              onClick={() => handleLinkClick("shop")}
              className={activeLink === "shop" ? "active-link" : ""}
            >
              <i className="bi bi-bag-fill"></i> SHOP
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#contact"
              onClick={() => handleLinkClick("contact")}
              className={activeLink === "contact" ? "active-link" : ""}
            >
              <i className="bi bi-person-circle"></i> CONTACT
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default MinNavbar;
